import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { IconContext } from 'react-icons'
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from "react-icons/md";
import './css/footer.css'



type FooterProperties = {
    tech_state: any;
    can_start_labor: boolean;
    can_stop_labor: boolean;
    can_start_travel: boolean;
    can_start_travel_to_wo: boolean;
    can_stop_travel: boolean;
    can_start_diagnostic?: boolean;
    can_stop_diagnostic?: boolean;
    active_workorder_id?: number;
    can_start_idle?: boolean;
    can_stop_idle?: boolean;
    can_start_other?: boolean;
    can_stop_other?: boolean;
    onTechStateChanged(workorder_id: number, workorder: any): void;
    onStartTechTime(workorder_id: number, timeType: string): void;
    onStopTechTime(workorder_id: number, timeType: string): void;
    loading: boolean;
}

export default function Footer(props: FooterProperties){

    const onStartTechTimeProxy = (timeType: string) => {
        props.onStartTechTime(props.active_workorder_id ? props.active_workorder_id : 0, timeType);
    }


    return (<div className="tech_app_footer">
        {
        !props.loading && props.active_workorder_id && !props.can_start_travel && !props.can_start_labor && !props.can_stop_travel && !props.can_stop_labor
            && !props.can_start_diagnostic && !props.can_stop_diagnostic && !props.can_start_idle && !props.can_stop_idle
            && !props.can_start_other && !props.can_stop_other ?
        (<span>YOU ARE NOT ASSIGNED TO THIS WO TODAY OR YOU ARE CURRENTLY CLOCKED INTO ANOTHER WO.</span>) : (<></>)
        }
        {
        props.can_start_travel && props.active_workorder_id ?
        (<IconContext.Provider value={{ color: '#ffffff'}}>
            <Tooltip title="Start Travel">
                <IconButton onClick={() => {onStartTechTimeProxy('travel')}}><FaIcons.FaCarAlt/></IconButton>
            </Tooltip>
        </IconContext.Provider>):(<></>)
        }
        {
        props.can_stop_travel && props.active_workorder_id ?
        (
        <><IconContext.Provider value={{ color: '#008000'}}>
            <IconButton disabled><FaIcons.FaCarAlt/></IconButton>
        </IconContext.Provider>
        <IconContext.Provider value={{ color: '#ff0000'}}>
            <Tooltip title="Stop Travel">
                <IconButton onClick={()=>{props.onStopTechTime(props.active_workorder_id || 0, 'travel')}}><FaIcons.FaStopCircle/></IconButton>
            </Tooltip>
        </IconContext.Provider></>):(<></>)
        }
        {props.can_start_labor && props.active_workorder_id ? (
            <IconContext.Provider value={{ color: '#ffffff'}}>
                <Tooltip title="Start Labor">
                    <IconButton onClick={()=>{onStartTechTimeProxy('wo_labor')}}><FaIcons.FaWrench/></IconButton>
                </Tooltip>
            </IconContext.Provider>) : (<></>)}
        {props.can_stop_labor && props.active_workorder_id ? (
            <>
            <IconContext.Provider value={{ color: '#008000'}}>
                <IconButton disabled><FaIcons.FaWrench/></IconButton>
                <span>{'WO-'+('' + props.active_workorder_id).padStart(5, '0')}</span>
            </IconContext.Provider>
            <IconContext.Provider value={{ color: '#ff0000'}}>
                <Tooltip title="Stop Labor">
                    <IconButton onClick={()=>{props.onStopTechTime(props.active_workorder_id || 0, 'wo_labor')}}><FaIcons.FaStopCircle/></IconButton>
                </Tooltip>
            </IconContext.Provider>
            </>
            ) : (<></>)}
        {props.can_start_diagnostic && props.active_workorder_id ? (
            <IconContext.Provider value={{ color: '#ffffff'}}>
                <Tooltip title="Start Diagnostic">
                    <IconButton onClick={()=>{onStartTechTimeProxy('diagnostic')}}><FaIcons.FaStethoscope/></IconButton>
                </Tooltip>
            </IconContext.Provider>) : (<></>)}
        {props.can_stop_diagnostic && props.active_workorder_id ? (
            <>
            <IconContext.Provider value={{ color: '#008000'}}>
                <IconButton disabled><FaIcons.FaStethoscope/></IconButton>
                <span>{'WO-'+('' + props.active_workorder_id).padStart(5, '0')}</span>
            </IconContext.Provider>
            <IconContext.Provider value={{ color: '#ff0000'}}>
                <Tooltip title="Stop Diagnostic">
                    <IconButton onClick={()=>{props.onStopTechTime(props.active_workorder_id || 0, 'diagnostic')}}><FaIcons.FaStopCircle/></IconButton>
                </Tooltip>
            </IconContext.Provider>
            </>
            ) : (<></>)}
        {props.can_start_idle && !props.active_workorder_id ? (<IconContext.Provider value={{ color: '#ffffff'}}>
                <Tooltip title="Start Idle Time">
                    <IconButton onClick={()=>{onStartTechTimeProxy('idle')}}><MdIcons.MdAirlineSeatReclineNormal/></IconButton>
                </Tooltip>
            </IconContext.Provider>) : (<></>)
        }
        {props.can_stop_idle && !props.active_workorder_id ? (
            <>
            <IconContext.Provider value={{ color: '#008000'}}>
                <IconButton disabled><MdIcons.MdAirlineSeatReclineNormal/></IconButton>
            </IconContext.Provider>
            <IconContext.Provider value={{ color: '#ff0000'}}>
                <Tooltip title="Stop Idle Time">
                    <IconButton onClick={()=>{props.onStopTechTime(props.active_workorder_id || 0, 'idle')}}><FaIcons.FaStopCircle/></IconButton>
                </Tooltip>
            </IconContext.Provider>
            </>):
            (<></>)
        }
    </div>)
}